/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface FailCardTransactionCardTransactionTransactionRecordListInner
 */
export interface FailCardTransactionCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
}

export const FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


